module.exports = __webpack_public_path__ + "static/media/17.33e07dc4.JPG";